import React, { Component } from 'react';
import ModalAvailability from './ModalAvailability';
import ModalServices from './ModalServices';
import ModalAccept from './ModalAccept';
import ModalCancel from './ModalCancel';
import Gravatar from 'react-gravatar';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';


class InquiryQuickview extends Component {
  render() {
    const {modalHandler, proposalHandler, closeHandler, quickviewInquiry, bus_book_type_stage_list, stageHandler} = this.props;
    if (!quickviewInquiry) return <React.Fragment>No Inquiry</React.Fragment>;
    return (
        <PerfectScrollbar>
        <div className="quickview-body">
          <div className="card card-inverse mb-0 cursor-pointer" onClick={closeHandler}>
            <div className="card-body text-center pb-10">
              <Gravatar email={quickviewInquiry.email} size={96} rating="pg" default="identicon" className="avatar avatar-xxl avatar-bordered" />
              <h4 className="mt-2 mb-0"><a className="hover-primary text-white" href="#">{quickviewInquiry.full_name}</a></h4>
              <span><i className="fa fa-envelope w-20px"></i> {quickviewInquiry.email}</span><br/>
              <span><i className="fa fa-phone w-20px"></i> {quickviewInquiry.phone}</span>
            </div>
          </div>
          <div className="quickview-block form-type-material pb-0">
              <dl className="row">
                <dt className="col-sm-3">Ready Time</dt>
                <dd className="col-sm-9">{quickviewInquiry.date} @ {quickviewInquiry.ready_time}</dd>
                <dt className="col-sm-3">Location</dt>
                <dd className="col-sm-9" style={{lineHeight:18+'px'}}>
                <address>
                  <strong>{quickviewInquiry.location_name} <a target="_blank" href={'http://maps.google.com/?q='+quickviewInquiry.address + quickviewInquiry.address2}><i className="fa fa-external-link text-info"></i></a></strong><br/>
                  {quickviewInquiry.address}<br/>
                  {quickviewInquiry.address2}
                </address>
                </dd>
                {quickviewInquiry.location_instructions !== '' ?
                <React.Fragment>
                <dt className="col-sm-3">Instructions</dt>
                <dd className="col-sm-9" style={{lineHeight:18+'px'}}>{quickviewInquiry.location_instructions}</dd>
                </React.Fragment>
                : null}
                {quickviewInquiry.referral !== '' ?
                <React.Fragment>
                <dt className="col-sm-3">Referral</dt>
                <dd className="col-sm-9" style={{lineHeight:18+'px'}}>{quickviewInquiry.referral}</dd>
                </React.Fragment>
                : null}
                {quickviewInquiry.planner !== '' ?
                <React.Fragment>
                <dt className="col-sm-3">Wedding Planner</dt>
                <dd className="col-sm-9" style={{lineHeight:18+'px'}}>{quickviewInquiry.planner}</dd>
                </React.Fragment>
                : null}
                <dt className="col-sm-3">Modified</dt>
                <dd className="col-sm-9">{quickviewInquiry.last_modified}<br/><strong>{quickviewInquiry.age_of}</strong></dd>
                <dt className="col-sm-3">Stage</dt>
                <dd className="col-sm-9">
                  <select className="form-control" value={quickviewInquiry.bus_book_type_stage_id} onChange={stageHandler}>
                    {bus_book_type_stage_list.map((option, index)=>
                      <option key={index} value={option.id}>{option.stage_name}</option>
                    )}
                  </select>
                </dd>
              </dl>
          </div>
        </div>
        <footer className="p-12 text-center">
          <div className="btn-group btn-block btn-group-vertical">
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => modalHandler(quickviewInquiry, ModalServices, 'Requested Services')}><i className="fa fa-fw fa-scissors"></i> Requested Services</button>
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => modalHandler(quickviewInquiry, ModalAvailability, "Availability for " + quickviewInquiry.date + " @ " + quickviewInquiry.ready_time)}><i className="fa fa-fw fa-calendar"></i> Availability</button>
              {quickviewInquiry.current_stage_id === 2 ? <React.Fragment><button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => modalHandler(quickviewInquiry, ModalAccept, "Accept/Decline: " + quickviewInquiry.full_name)}><i className="fa fa-fw fa-check"></i> Accept/Decline</button></React.Fragment> : null}
              {quickviewInquiry.current_stage_id === 3 || quickviewInquiry.current_stage_id === 4 ? <React.Fragment><button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={() => proposalHandler(quickviewInquiry)}><i className="fa fa-fw fa-edit"></i> Proposal</button></React.Fragment> : null}
              <a className="btn btn-lg btn-outline btn-block btn-secondary" href={"mailto:" + quickviewInquiry.email}><i className="fa fa-fw fa-envelope"></i> Message</a>
              <button className="btn btn-lg btn-outline btn-block btn-danger" onClick={(event) => modalHandler(quickviewInquiry, ModalCancel, "Cancel Inquiry")}><i className="fa fa-fw fa-trash"></i> Cancel Inquiry</button>
              <button className="btn btn-lg btn-outline btn-block btn-info" onClick={closeHandler}><i className="fa fa-fw fa-close"></i> Close</button>
          </div>
        </footer>
        </PerfectScrollbar>
    )
  }
}

export default InquiryQuickview;



// WEBPACK FOOTER //
// ./src/components/business/InquiryQuickview.js